// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2wKtJ","requiredAsterisk":"Info_requiredAsterisk__3NMku"};